/* tslint:disable */
/* eslint-disable */
/**
 * Minimal API - JWT Authentication with Swagger demo
 * Implementing JWT Authentication in Minimal API
 *
 * The version of the OpenAPI document: v1
 * Contact: mbobka@mbobka.com
 *
 * NOTE: Partially hand-maintained (the OpenAPI generator is not wired up in this repo).
 * Keep the request/response shapes in sync with sandbox_app.Operations.AuthOperations.
 */


import * as runtime from '../runtime';
import type {
  AuthModel,
  ConfirmEmailRequest,
  LoginRequest,
  RefreshRequest,
  RegisterRequest,
  RegisterResult,
  ResendCodeRequest,
  UserModel,
} from '../models';
import {
    AuthModelFromJSON,
    ConfirmEmailRequestToJSON,
    LoginRequestToJSON,
    RefreshRequestToJSON,
    RegisterRequestToJSON,
    RegisterResultFromJSON,
    ResendCodeRequestToJSON,
    UserModelFromJSON,
} from '../models';

export interface AuthForgotPasswordPostRequest {
    email: string;
}

export interface AuthLoginPostRequest {
    loginRequest: LoginRequest;
}

export interface AuthRegisterPostRequest {
    registerRequest: RegisterRequest;
}

export interface AuthConfirmEmailPostRequest {
    confirmEmailRequest: ConfirmEmailRequest;
}

export interface AuthResendCodePostRequest {
    resendCodeRequest: ResendCodeRequest;
}

export interface AuthRefreshPostRequest {
    refreshRequest: RefreshRequest;
}

/**
 *
 */
export class AuthOperationsApi extends runtime.BaseAPI {

    /**
     */
    async authForgotPasswordPostRaw(requestParameters: AuthForgotPasswordPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.email === null || requestParameters.email === undefined) {
            throw new runtime.RequiredError('email','Required parameter requestParameters.email was null or undefined when calling authForgotPasswordPost.');
        }

        const queryParameters: any = {};

        if (requestParameters.email !== undefined) {
            queryParameters['email'] = requestParameters.email;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/auth/forgot_password`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async authForgotPasswordPost(requestParameters: AuthForgotPasswordPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.authForgotPasswordPostRaw(requestParameters, initOverrides);
    }

    /**
     */
    async authLoginPostRaw(requestParameters: AuthLoginPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuthModel>> {
        if (requestParameters.loginRequest === null || requestParameters.loginRequest === undefined) {
            throw new runtime.RequiredError('loginRequest','Required parameter requestParameters.loginRequest was null or undefined when calling authLoginPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/auth/login`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LoginRequestToJSON(requestParameters.loginRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AuthModelFromJSON(jsonValue));
    }

    /**
     */
    async authLoginPost(requestParameters: AuthLoginPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuthModel> {
        const response = await this.authLoginPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async authRegisterPostRaw(requestParameters: AuthRegisterPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RegisterResult>> {
        if (requestParameters.registerRequest === null || requestParameters.registerRequest === undefined) {
            throw new runtime.RequiredError('registerRequest','Required parameter requestParameters.registerRequest was null or undefined when calling authRegisterPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/auth/register`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RegisterRequestToJSON(requestParameters.registerRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RegisterResultFromJSON(jsonValue));
    }

    /**
     */
    async authRegisterPost(requestParameters: AuthRegisterPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RegisterResult> {
        const response = await this.authRegisterPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async authConfirmEmailPostRaw(requestParameters: AuthConfirmEmailPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuthModel>> {
        if (requestParameters.confirmEmailRequest === null || requestParameters.confirmEmailRequest === undefined) {
            throw new runtime.RequiredError('confirmEmailRequest','Required parameter requestParameters.confirmEmailRequest was null or undefined when calling authConfirmEmailPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/auth/confirm_email`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ConfirmEmailRequestToJSON(requestParameters.confirmEmailRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AuthModelFromJSON(jsonValue));
    }

    /**
     */
    async authConfirmEmailPost(requestParameters: AuthConfirmEmailPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuthModel> {
        const response = await this.authConfirmEmailPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async authResendCodePostRaw(requestParameters: AuthResendCodePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RegisterResult>> {
        if (requestParameters.resendCodeRequest === null || requestParameters.resendCodeRequest === undefined) {
            throw new runtime.RequiredError('resendCodeRequest','Required parameter requestParameters.resendCodeRequest was null or undefined when calling authResendCodePost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/auth/resend_code`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ResendCodeRequestToJSON(requestParameters.resendCodeRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RegisterResultFromJSON(jsonValue));
    }

    /**
     */
    async authResendCodePost(requestParameters: AuthResendCodePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RegisterResult> {
        const response = await this.authResendCodePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async authRefreshPostRaw(requestParameters: AuthRefreshPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuthModel>> {
        if (requestParameters.refreshRequest === null || requestParameters.refreshRequest === undefined) {
            throw new runtime.RequiredError('refreshRequest','Required parameter requestParameters.refreshRequest was null or undefined when calling authRefreshPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/auth/refresh`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RefreshRequestToJSON(requestParameters.refreshRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AuthModelFromJSON(jsonValue));
    }

    /**
     */
    async authRefreshPost(requestParameters: AuthRefreshPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuthModel> {
        const response = await this.authRefreshPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async authVerifyTokenPostRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/auth/verify_token`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserModelFromJSON(jsonValue));
    }

    /**
     */
    async authVerifyTokenPost(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserModel> {
        const response = await this.authVerifyTokenPostRaw(initOverrides);
        return await response.value();
    }

}
